import * as React from 'react';
import { BodySmallRegular } from 'smoothie';

import { useAccountVerificationLetterFlow } from '../../../banking/components/account-verification-letter';
import { useSendEmailToSupport } from '../../../common/hooks/useSendEmailToSupport';
import { SUPPORT_EMAIL } from '../../types/constants';

const AnswerLink = ({
    onPress,
    children,
}: {
    onPress: () => void;
    children: React.ReactNode;
}) => (
    <BodySmallRegular
        textDecorationLine="underline"
        onPress={onPress}
        hoverStyle={{ cursor: 'pointer' }}
    >
        {children}
    </BodySmallRegular>
);

export const ProviderRecognitionFAQAnswer = () => {
    const sendEmailToSupport = useSendEmailToSupport();
    const {
        openSheet: openDirectDepositLetter,
        flowElements: directDepositLetterFlowElements,
    } = useAccountVerificationLetterFlow({
        variant: 'direct-deposit',
    });
    const {
        openSheet: openBillPayLetter,
        flowElements: billPayLetterFlowElements,
    } = useAccountVerificationLetterFlow({
        variant: 'bill-pay',
    });

    return (
        <>
            <BodySmallRegular>
                If your payroll provider doesn’t recognize our routing number,
                you can submit this{' '}
                <AnswerLink onPress={openDirectDepositLetter}>
                    account verification letter
                </AnswerLink>
                . For all other bill providers, you can submit{' '}
                <AnswerLink onPress={openBillPayLetter}>this letter</AnswerLink>{' '}
                to verify your account. For additional support, reach out to{' '}
                <AnswerLink
                    onPress={() => {
                        void sendEmailToSupport();
                    }}
                >
                    {SUPPORT_EMAIL}
                </AnswerLink>
                .
            </BodySmallRegular>
            {directDepositLetterFlowElements}
            {billPayLetterFlowElements}
        </>
    );
};
